<div class="tab-slider--nav tabs-ahorros {{ styleClass }}">
	<ul class="tab-slider--tabs" [ngClass]="{ slide: !showTab1 }">
		<li class="tab-slider--trigger" rel="tab1" [ngClass]="{ active: showTab1 }" (click)="clickTab(true)">
			{{ title.title1 }}
		</li>
		<li class="tab-slider--trigger" rel="tab2" [ngClass]="{ active: !showTab1 }" (click)="clickTab(false)">
			{{ title.title2 }}
		</li>
	</ul>
</div>

<div class="tab-slider--container content_tabs_ahorros">
	<div id="tab1" class="tab-slider--body" *ngIf="showTab1">
		<ng-content select="[tab1]"></ng-content>
	</div>

	<div id="tab2" class="tab-slider--body" *ngIf="!showTab1">
		<ng-content select="[tab2]"></ng-content>
	</div>
</div>
